import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import FieldWrapper from '../_components/FieldWrapper';
import { useFieldWrapper, } from '../_components/FieldWrapper.hooks';
import { useAutoTextarea } from './Textarea.hooks';
const Textarea = forwardRef((props, ref) => {
    const { autoGrow = true, rows = 3, maxRows, maxLength, onEnter } = props;
    const FW = useFieldWrapper(Object.assign(Object.assign({}, props), { clearedValue: '' }), ref);
    const { limitedRows } = useAutoTextarea({
        fieldRef: FW.originalFieldRef,
        value: FW.value,
        autoGrow,
        minRows: rows,
        maxRows,
    });
    function handleOnKeyDown(event) {
        var _a;
        if (onEnter && event.key === 'Enter' && !event.shiftKey && !FW.disabled && !FW.readonly) {
            event.preventDefault();
            onEnter(event);
        }
        (_a = FW.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(FW, event);
    }
    return (_jsx(FieldWrapper, Object.assign({ element: 'textarea', props: FW }, { children: _jsx("textarea", { ref: FW.originalFieldRef, id: FW.id.toString(), value: FW.value, onChange: (e) => FW.onChange(e.target.value), rows: limitedRows, 
            //
            readOnly: FW.readonly, disabled: FW.disabled, placeholder: FW.placeholder, maxLength: maxLength, onFocus: FW.onFocus, onBlur: FW.onBlur, onKeyDown: handleOnKeyDown }) })));
});
export default observer(Textarea);
